import { DEFAULT_MINIMUM_BUDGET } from '@brandzooka/jsconst/src/campaign/budget';
import { useGAS } from 'src/GlobalAppState/context';

export const useOrganizationMinBudget = () => {
  const { organization } = useGAS();

  return organization?.overrides?.minimumCampaignBudget ?? DEFAULT_MINIMUM_BUDGET;
};
